/**
 * @module
 * The entry every page loads: the host serves one `index.html` for every
 * path, and this picks the page's bundle from the URL and loads it. The
 * specifier is computed, so esbuild leaves the import to the browser and
 * each bundle stays separate (the stage's must not reach the desktop's).
 */
import { entryOf } from "./boot/entry.ts";

const entry = entryOf(globalThis.location.pathname);
await import(
  new URL(`/static/build/${entry}.js`, globalThis.location.origin).href
);
